import "./styles.scss";

import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { Fragment, useMemo, useState } from "react";

const CommentsClassesHeld = ({
  commentsTeacher,
  setCommentsTeacher,
  suggestedExercisesByTeacher,
  setSuggestedExercisesByTeacher,
  suggestedExercisesOptions = [],
}) => {
  const { t } = useTranslation();

  const [query, setQuery] = useState("");
  const [open, setOpen] = useState(false);

  const normalizedSelected = useMemo(() => {
    if (!Array.isArray(suggestedExercisesByTeacher)) return [];
    return suggestedExercisesByTeacher.map((s) => (typeof s === "string" ? s.trim() : "")).filter(Boolean);
  }, [suggestedExercisesByTeacher]);

  const normalizedOptions = useMemo(() => {
    const options = Array.isArray(suggestedExercisesOptions) ? suggestedExercisesOptions : [];

    const normalized = options
      .map((item) => {
        if (typeof item === "string") return item;
        if (item && typeof item === "object" && typeof item.classTitle === "string") return item.classTitle;
        return "";
      })
      .map((s) => (typeof s === "string" ? s.trim() : ""))
      .filter(Boolean);

    return Array.from(new Set(normalized));
  }, [suggestedExercisesOptions]);

  const filteredSuggestions = useMemo(() => {
    const q = String(query || "")
      .trim()
      .toLowerCase();
    const selectedSet = new Set(normalizedSelected.map((s) => s.toLowerCase()));

    const base = normalizedOptions.filter((s) => !selectedSet.has(s.toLowerCase()));

    if (!q) return [];

    return base.filter((s) => s.toLowerCase().includes(q));
  }, [query, normalizedSelected, normalizedOptions]);

  const addSuggestion = (value) => {
    const v = (value || "").trim();
    if (!v) return;
    const selected = Array.isArray(suggestedExercisesByTeacher) ? suggestedExercisesByTeacher : [];

    if (selected.some((s) => (s || "").trim().toLowerCase() === v.toLowerCase())) return;

    setSuggestedExercisesByTeacher([...selected, v]);
    setQuery("");
    setOpen(false);
  };

  const removeSuggestion = (value) => {
    const selected = Array.isArray(suggestedExercisesByTeacher) ? suggestedExercisesByTeacher : [];
    setSuggestedExercisesByTeacher(selected.filter((s) => (s || "").trim() !== value));
  };

  return (
    <Fragment>
      <div className="wrapperInputs">
        <h3>{t("CLASS_COMMENTARY")}*</h3>
        <textarea value={commentsTeacher} onChange={(e) => setCommentsTeacher(e.target.value)} />
      </div>

      <div className="wrapperInputs">
        <h3>{t("SUGESTIONS")}</h3>

        <div className="suggestions">
          {normalizedSelected.length > 0 && (
            <div className="suggestions__selected">
              {normalizedSelected.map((item) => (
                <button key={item} type="button" className="suggestions__chip" onClick={() => removeSuggestion(item)}>
                  {item}
                  <IoClose size={12} />
                </button>
              ))}
            </div>
          )}

          <input
            value={query}
            onFocus={() => setOpen(true)}
            placeholder={t("TYPE_YOUR_SUGGESTIONS")}
            onChange={(e) => {
              setQuery(e.target.value);
              setOpen(true);
            }}
          />

          {open && filteredSuggestions.length > 0 && (
            <div className="suggestions__dropdown" tabIndex={-1}>
              {filteredSuggestions.map((filteredSuggestion) => (
                <button
                  type="button"
                  key={filteredSuggestion}
                  className="suggestions__item"
                  onMouseDown={(e) => e.preventDefault()}
                  onClick={() => addSuggestion(filteredSuggestion)}
                >
                  {filteredSuggestion}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default CommentsClassesHeld;
